<template>
  <div class="youtube-modal u-padd-top-qtr u-padd-btm u-padd-sides" style="margin-top: 30px;">
    <div class="video">
      <div class="video__container">
        <div class="youtube-wrapper" style="padding-bottom:56.25%;" data-youtube-id="id">
          <iframe allow="autoplay" allowfullscreen="1" :src="getYoutubeUrl()" width="100%" height="100%"
            frameborder="0"></iframe>
        </div>
        <div v-if="showTitle" class="u-flex u-flex--row u-flex--align-items-center u-mrg-top">
          <span class="play-btn-sm"></span>
          <h3 class="h-xs u-mrg-none" v-html="title"></h3>
        </div>
      </div>
      <h3 class="h-sm" v-if="promoTitle" v-html="promoTitle"></h3>
      <div v-if="modalContent" v-html="modalContent"></div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "../utils/events/event-bus.js";
export default {
  props: {
    showTitle: {
      default: false,
      type: Boolean,
    },
    id: null,
    start: "",
    lang: "",
    title: null,
    promoTitle: null,
    modalContent: null,
    isActive: false,
    modalShow: false,
  },
  data() {
    return {
      shown: false,
    };
  },
  mounted() {
    this.shown = this.modalShow;
  },
  methods: {
    getYoutubeUrl() {

      var url = 'https://www.youtube.com/embed/' + this.id + '?enablejsapi=1&autoplay=1&widgetid=1&cc_load_policy=0&rel=0&modestbranding=1&controls=1&iv_load_policy=3';

      if (this.start != null && this.start != "")
        url += this.start;

      if (this.lang != null && this.lang != "")
        url += this.lang;

      return url;
    }
  }
};
</script>
